export const app = {
  header: {
    backgroundImages: [
      'https://imagedelivery.net/Z5lEYwq8x5HYlOcAYUT42Q/2f30b6c6-35da-4942-eda4-4892cd183e00/public',
      'https://imagedelivery.net/Z5lEYwq8x5HYlOcAYUT42Q/12b1a201-d6b5-4632-c40f-4c10e4281600/public',
      'https://imagedelivery.net/Z5lEYwq8x5HYlOcAYUT42Q/ab3a4c7d-b8fe-4aee-9c41-92035d7d4400/public',
    ]
  }
};
